jQuery(document).ready(function ($) {
  // Wrap characters in span
  $('.client-testimonial').each(function () {
    var text = $(this).text().trim();
    var chars = text
      .split('')
      .map(function (ch) {
        return '<span>' + ch + '</span>';
      })
      .join('');
    $(this).html(chars);
  });

  // Testimonial Slider
  $('.testimonial-slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 0,
    autoplay: false,
    adaptiveHeight: true,
  });

  function animateText(slideIndex, onComplete) {
    var $chars = $(".slick-slide[data-slick-index='" + slideIndex + "'] .client-testimonial span");
    $chars.css('opacity', 0.3);
    $chars.slice(0, 23).css('opacity', 1);

    setTimeout(function () {
      var i = 23;
      function showNext() {
        if (i < $chars.length) {
          $chars.eq(i).animate({ opacity: 1 }, 200);
          i++;
          setTimeout(showNext, 30);
        } else {
          // Jab last character bhi animate ho jaye
          if (onComplete) onComplete();
        }
      }
      showNext();
    }, 800);
  }

  // Start from first slide
  animateText(0, function () {
    $('.testimonial-slider').slick('slickNext');
  });

  // On slide change
  $('.testimonial-slider').on('afterChange', function (event, slick, currentSlide) {
    animateText(currentSlide, function () {
      $('.testimonial-slider').slick('slickNext');
    });
  });

  // Top Tip Slider
  $('.top-tip-slider').slick({
    arrows: true,
    dots: false,
    infinite: false,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    slidesPerRow: 1,
    slidesToScroll: 1,
    prevArrow: '.top-tips-slider-section .prev-arrow',
    nextArrow: '.top-tips-slider-section .next-arrow',
  });

  // Journal Slider
  $('.journal-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true },
      },
      {
        breakpoint: 769,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  });

  // Instagram Slider
  $('.instagram-slider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: '.instagram-data .prev-arrow',
    nextArrow: '.instagram-data .next-arrow',
  });

  // Head Product Slider
  $('.head-product-slider').slick({
    dots: false,
    arrows: false,
    infinite: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // normal autoplay speed
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $('.menu-nav-item').on('mouseenter', function () {
    $(this).find('.head-product-slider').slick('setPosition');
  });

  // Override the first autoplay timing
  $('.head-product-slider').slick('slickPause'); // pause initially

  setTimeout(function () {
    $('.head-product-slider').slick('slickNext'); // move to next after 1s
    $('.head-product-slider').slick('slickPlay'); // resume normal autoplay (5000ms)
  }, 1000);

  // Home Hero Slider
  $('.home-hero-slider').slick({
    dots: true,
    infinite: false,
    // speed: 800,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 10000,
    infinte: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    pauseOnHover: false,
  });

  // Trending Products Slider Initialize
  $('.trending-products-slider-section').each(function () {
    var $section = $(this);

    $section.find('.trending-products-slider').slick({
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      prevArrow: $section.find('.prev-arrow'),
      nextArrow: $section.find('.next-arrow'),
      responsive: [
        { breakpoint: 1025, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
    });
  });

  // Product Slider Story (nav + detail synced)
  $('.product-slider-story').each(function () {
    var $section = $(this);
    var $nav = $section.find('.product-slider-story__nav');
    var $detail = $section.find('.product-slider-story__detail');
    var $progressFill = $section.find('.product-slider-story__nav-progress-fill');

    if (!$nav.length || !$detail.length) return;

    // Deep-linking: resolve target slide index from query params BEFORE init
    function normalizeProductParam(val) {
      if (!val) return '';
      var s = String(val).trim();
      // allow passing full product path e.g. /products/handle
      s = s.replace(/^https?:\/\/[^/]+/i, '');
      s = s.replace(/^\/?products\//i, '');
      return s.trim().toLowerCase();
    }

    function getTargetIndexFromQuery() {
      if (typeof window === 'undefined' || !window.location || !window.location.search) return -1;
      var params = new URLSearchParams(window.location.search);
      var raw =
        params.get('product') ||
        params.get('productHandle') ||
        params.get('productTitle') ||
        params.get('product_name') ||
        params.get('productName');

      var target = normalizeProductParam(raw);
      if (!target) return -1;

      var $items = $section.find('.product-slider-story__nav-item');
      if (!$items.length) return -1;

      var idx = -1;
      $items.each(function (i) {
        var $item = $(this);
        var titleSlug = normalizeProductParam($item.data('product-title-slug'));
        var title = String($item.data('product-title') || '').trim().toLowerCase();

        // Prefer matching the URL-friendly title slug (e.g. "Age Defiance" => "age-defiance")
        if (titleSlug === target || title === target) {
          idx = i;
          return false; // break
        }
      });

      return idx;
    }

    var deepLinkIndex = getTargetIndexFromQuery();

    if ($nav.hasClass('slick-initialized')) $nav.slick('unslick');
    if ($detail.hasClass('slick-initialized')) $detail.slick('unslick');

    $detail.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      speed: 500,
      adaptiveHeight: true,
      fade: true,
      asNavFor: $nav,
    });

    $nav.slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: false,
      speed: 500,
      focusOnSelect: true,
      swipeToSlide: true,
      prevArrow: $section.find('.product-slider-story__arrows .prev-arrow'),
      nextArrow: $section.find('.product-slider-story__arrows .next-arrow'),
      asNavFor: $detail,
      responsive: [
        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 1025, settings: { slidesToShow: 2.2, slidesToScroll: 1 } },
        { breakpoint: 769, settings: { slidesToShow: 1.4, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1.1, slidesToScroll: 1 } },
      ],
    });

    function updateNavProgress(currentSlide) {
      if (!$progressFill.length || !$nav.hasClass('slick-initialized')) return;

      var slick = $nav.slick('getSlick');
      var slideCount = slick.slideCount || 0;
      if (!slideCount) return;

      var idx = Math.max(0, Math.min(slideCount - 1, Number(currentSlide) || 0));

      // Fixed-width indicator that moves across the bar:
      // width is 1 segment (100/slideCount), offset is idx segments.
      var segment = 100 / slideCount;
      var offset = idx * segment;

      $progressFill.css({
        width: segment + '%',
        left: offset + '%',
        transform: 'translateX(0)',
      });
    }

    // Initial + on change/resize/breakpoints
    $nav.on('init', function (e, slick) {
      updateNavProgress(slick.currentSlide || 0);
    });

    $nav.on('afterChange', function (e, slick, currentSlide) {
      updateNavProgress(currentSlide);
    });

    $nav.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
      updateNavProgress(nextSlide);
    });

    $nav.on('setPosition breakpoint', function () {
      var slick = $nav.slick('getSlick');
      updateNavProgress(slick.currentSlide || 0);
    });

    // Apply deep-link after both sliders exist
    if (deepLinkIndex >= 0) {
      setTimeout(function () {
        if ($nav.hasClass('slick-initialized')) {
          $nav.slick('slickGoTo', deepLinkIndex, true);
        }
        if ($detail.hasClass('slick-initialized')) {
          $detail.slick('slickGoTo', deepLinkIndex, true);
        }
        updateNavProgress(deepLinkIndex);
      }, 0);
    }
  });

  // Promise Card Slider
  $('.promise-card-slider').slick({
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1025, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  // Single Product Slider (mobile only)
  function initSlick() {
    if ($(window).width() < 992) {
      if (!$('.single-product-slider').hasClass('slick-initialized')) {
        $('.single-product-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: true,
        });
      }
    } else {
      if ($('.single-product-slider').hasClass('slick-initialized')) {
        $('.single-product-slider').slick('unslick');
      }
    }
  }
  initSlick();
  $(window).resize(initSlick);

  // Order Details Slider
  $('.order-details-slider').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 2,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 425, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  // Recent View Order Slider
  $('.recent-view-order-slider').slick({
    arrows: false,
    dots: false,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 4, slidesToScroll: 1 } },
      { breakpoint: 425, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  });

  // Header Top Slider
  $('.header-top-slider').slick({
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    speed: 800,
    autoplaySpeed: 3000,
    prevArrow: '.header-top-slider-container .prev-arrow',
    nextArrow: '.header-top-slider-container .next-arrow',
  });
});
